import React, { MouseEvent } from 'react';
import PropTypes, { InferProps } from 'prop-types';

import classnames from 'classnames/bind';

import Lock from '@COMPONENTS/SHARED/Lock';

import IconLoader from '@COMPONENTS/COMMON/iconLoader/iconLoader';
import styles from './SquareButton.module.scss';

const cx: CX = classnames.bind(styles);

function SquareButton(props: Props) {
    const {
        title, onClick, highlighted, locked, img, titleClassName,
    } = props;

    function handleClick(event: MouseEvent<HTMLButtonElement>) {
        if (!locked) {
            onClick(event);
        }
    }

    return (
        <div
            className={cx({
                'square-button': true,
                highlighted,
                locked,
            })}
        >
            {
                locked
                && (
                    <div className={cx('lock-wrapper')}>
                        <Lock size="large" />
                    </div>
                )
            }

            <button
                className="clear-button"
                type="button"
                onClick={(e) => handleClick(e)}
            >
                <div className={cx('content')}>
                    {img && <IconLoader iconName={img} />}
                    <div className={cx('titleWrap', titleClassName)}>{title}</div>
                </div>
            </button>
        </div>
    );
}

SquareButton.defaultProps = {
    highlighted: false,
    locked: false,
    img: '',
    titleClassName: '',
};

SquareButton.propTypes = {
    locked: PropTypes.bool,
    title: PropTypes.string.isRequired,
    onClick: PropTypes.func.isRequired,
    highlighted: PropTypes.bool,
    img: PropTypes.string,
    titleClassName: PropTypes.string,
};

type Props = InferProps<typeof SquareButton.propTypes> & typeof SquareButton.defaultProps;

export default SquareButton;
